import { Listbox, Transition } from "@headlessui/react";
import { truncate, size, trim, get, has } from "lodash";
import { Fragment } from "react";
import classNames from "classnames";
import AwesomeIcon from "../AwesomeIcon";
import { faChevronUp } from "@fortawesome/pro-solid-svg-icons";
import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import { getTrimmedWorkspaceId } from "../../utils";
import { useTranslation } from "react-i18next";

const SourceDropdown = (props) => {
  const {
    options,
    selectedOption,
    onChange,
    onOpen,
    hasBorder,
    isLeftAligned,
    className = "",
    optionClassName = "",
    isBottomAligned,
    disabled = false,
    isWorkspace,
  } = props;
  let selectedLabel = get(selectedOption, ["label"], "");
  // selectedLabel = truncate(selectedLabel, { length: 20 });
  const { t } = useTranslation();

  return (
    <Listbox as="div" className="relative" value={selectedOption} onChange={onChange}>
      {({ open }) => (
        <>
          <Listbox.Button
            onClick={() => {
              if (!open) onOpen?.();
            }}
            className={classNames(
              "py-3 min-w-[200px] rounded-md flex items-center justify-between gap-4 text-gray-600 dark:text-gray-400 outline-none",
              {
                "border border-gray-500": hasBorder,
                [className]: !!className,
              }
            )}
            aria-disabled={disabled}
          >
            <span>
              {selectedLabel}{" "}
              <span className="uppercase hidden sm:inline-block">
                {selectedOption?.id && `| ${getTrimmedWorkspaceId(selectedOption?.id)}`}
              </span>
            </span>
            <AwesomeIcon
              name={faChevronUp}
              className={classNames("opacity-50 rotate-180", {
                "!rotate-0": open,
                hidden: disabled,
              })}
            />
          </Listbox.Button>
          <Transition
            enter="transition duration-100 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
          >
            <Listbox.Options
              className={classNames(
                "absolute z-50 l-3 flex flex-col min-w-[300px] max-h-[170px] overflow-y-auto scrollbar-light dark:scrollbar bg-gray-200 dark:bg-gray-800 text-gray-900 dark:text-gray-100 border border-gray-500 rounded-md text-left",
                {
                  "right-0": !isLeftAligned,
                  "bottom-[50px]": !isBottomAligned,
                  [optionClassName]: !![optionClassName],
                }
              )}
            >
              {options &&
                options?.map((opts, index) => {
                  const has_permission_key = has(opts, "has_permission");
                  const disabled =
                    (!opts?.has_permission && has_permission_key) ||
                    opts?.synced ||
                    opts?.disabled;
                  return (
                    <Listbox.Option
                      disabled={disabled}
                      key={opts?.id ?? opts?.value ?? index}
                      value={opts}
                      as={Fragment}
                      className={classNames({
                        "opacity-40 !cursor-not-allowed": disabled,
                      })}
                    >
                      {({ active, selected }) => (
                        <div
                          className={classNames(
                            "px-4 py-4 flex space-x-3 items-center cursor-pointer",
                            {
                              "border-b border-b-gray-500": size(options) - 1 !== index,
                              "bg-teal-500 text-gray-100 dark:bg-teal-800":
                                (active || selected) && !isWorkspace,
                              "bg-teal-500 text-gray-100 dark:bg-gray-700":
                                (active || selected) && isWorkspace,
                            }
                          )}
                        >
                          {
                            <AwesomeIcon
                              className={classNames("invisible", {
                                "!visible": selected && isWorkspace,
                              })}
                              name={faCheck}
                              size="sm"
                            />
                          }
                          <p className="flex-1">
                            {opts.label}{" "}
                            {opts?.id && `| ${getTrimmedWorkspaceId(opts?.id)}`}{" "}
                            {opts?.role && (
                              <span className="bg-gray-600 !text-gray-100 px-2 py-1 rounded-md ml-2">
                                {t(`user_roles.${opts?.role}`)}
                              </span>
                            )}
                          </p>
                          {((!opts?.has_permission && has_permission_key) ||
                            opts?.synced) && (
                            <p className="text-right">{t("no_access")}</p>
                          )}
                        </div>
                      )}
                    </Listbox.Option>
                  );
                })}
            </Listbox.Options>
          </Transition>
        </>
      )}
    </Listbox>
  );
};

export default SourceDropdown;
